/* eslint-disable */
import React, { useState, useEffect, useMemo } from "react";
import _Select from "../../generic/_Select";
import _DateFilters from "../../generic/_DateFilters";
import * as Yup from "yup";
import { useFormik } from "formik";
import PieChartReport from "./PieChartReport";
import GraphByDayDashboard from "./GraphByDayDashboard";
import { useQuery, useMutation } from "@tanstack/react-query";
import { ApiEndpoint } from "../../../utils/ApiEndpoint";
import { httpClient } from "../../../utils/HttpClient";
import { useAuth } from "../../../Context/AuthContext";
import _Button from "../../generic/_Button";
import { NotContent } from "../../ui/Form";
import DateFilters from "../../ui/Form/Period/DateFilters";
import { ErrorMessage } from "../../../utils/toastify";
import { Spinner } from "react-bootstrap";
import { MultiSelect } from "../../ui/Form/MultiSelect";
import { dateFormat, today } from "../../../utils/dateHelpers";
import CardsCustomers from "./CardsCustomers";
import Icon from "../../Icon";
import PartnerGraphDashboard from "./PartnerGraphDashboard";
import { errorLabels } from "../../../utils/helpers";
import { SelectAndSearch } from "../../ui/Form/SelectAndSearch";
const _CustomerDashboard = () => {
  const auth = useAuth();
  const { token } = auth.getSessionData();
  const [dataReport, setDataReport] = useState(null);
  const [dataBarChart, setDataBarChart] = useState([]);
  const [isClean, setIsClean] = useState(false);
  const [summaryPartners, setSummaryPartners] = useState([]);
  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    setFieldValue,
    submitForm,
    validateForm,
    resetForm,
  } = useFormik({
    initialValues: {
      id_customer: "",
      partner: [],
      period: {
        dateFrom: today("YYYY/MM/DD"),
        dateTo: today("YYYY/MM/DD"),
      },
    },
    validateOnMount: false,
    validationSchema: Yup.object({
      id_customer: Yup.string().required("El cliente es requerido"),
      partner: Yup.array()
        .min(1, "Al menos un partner es requerido")
        .required("El partner es requerido"),
      period: Yup.object({
        dateFrom: Yup.string().required("La fecha de inicio es requerida"),
        dateTo: Yup.string().required("La fecha de fin es requerida"),
      }),
    }),
    onSubmit: async (values) => {
      await onAction(values)
    },
  });

  const resolveCustomer = (idCustomer, customers) => {
    if (idCustomer === "all") return null;
    return customers.find(client => client.idcustomer === Number(idCustomer))?.uidCustomer ?? null;
  };
  
  const resolvePartners = (idCustomer, selected, partnerList) => {
    if (idCustomer === "all") return null;
    if (selected.includes("all")) {
      return partnerList.map(partner => partner.uidpartner).toString();
    }
    return selected.toString();
  };
  
  const buildPayload = (values, customers, partners) => ({
    from: values.period.dateFrom,
    to: values.period.dateTo,
    customer: resolveCustomer(values.id_customer, customers),
    partners: resolvePartners(values.id_customer, values.partner, partners),
  });
  
  const onAction = async (values) => {
    try {
      const dataToSubmit = buildPayload(values, customersList, partnerList);
  
      await Promise.all([
        mutatePieChart(dataToSubmit),
        mutateBarChart(dataToSubmit),
        mutatepartnersSummary(dataToSubmit),
      ]);
    } catch (error) {
      ErrorMessage(error.message);
    }
  };
  

  const { mutate: mutatePieChart, isPending: isPendingPie } = useMutation({
    mutationKey: ["reportDashboard"],
    mutationFn: async (values) => {
      const response = await httpClient(
        "POST",
        `${ApiEndpoint}dashboard/smrybycustomer`,
        values,
        token
      );
      return response.data;
    },
    onSuccess: (data) => {
      setDataReport(data);
    },
  });

  const { mutate: mutateBarChart, isPending: isPendingBar } = useMutation({
    mutationKey: ["reportBarChart"],
    mutationFn: async (values) => {
      const response = await httpClient(
        "POST",
        `${ApiEndpoint}dashboard/smrybycustomerbyday
`,
        values,
        token
      );

      return response.data;
    },
    onSuccess: (data) => {
      setDataBarChart(data);
    },
  });

  const { mutate: mutatepartnersSummary, isPending: isPendingPartnert} = useMutation({
    mutationKey: ["partnersSummary"],
    mutationFn: async (values) => {
      const response = await httpClient(
        "POST",
        `${ApiEndpoint}dashboard/smrybycustomerpartner`,
        values,
        token
      );
      return response.data;
    },
    onSuccess: (data) => {
      setSummaryPartners(data);
    },
  })

  const { data: partnerList } = useQuery({
    queryKey: ["partnersList", values.id_customer],
    queryFn: async () => {
      const response = await httpClient(
        "GET",
        `${ApiEndpoint}partners/${values.id_customer}`,
        {},
        token
      );

      return response?.data;
    },
    initialData: [],
    enabled: !!values.id_customer,
    refetchOnWindowFocus: false,
  });

  const partners = useMemo(() => {

    let partners = [
      {
        value: "",
        label: "Selecciona un partner",
      },
      {
        value: "all",
        label: "Todos",
      },
   
    ];


    if(partnerList.length > 0){
      partners = [
        {
          value: "",
          label: "Selecciona un partner",
        },
        {
          value: "all",
          label: "Todos",
        },
        ...partnerList.map((partner) => ({
          value: partner.uidpartner,
          label: partner.name,
        })),
      ]
    }
    

    return partners


  }, [partnerList])

  const { data: customersList } = useQuery({
    queryKey: ["customersList"],
    queryFn: async () => {
      const response = await httpClient(
        "GET",
        `${ApiEndpoint}customers`,
        {},
        token
      );

      return response.data;
    },
    refetchOnWindowFocus: false,
    initialData: [],
  });

  const _validate = async () => {
    try {
      const isValid = await validateForm();
      const errors = errorLabels(isValid);

      if (Object.keys(isValid).length !== 0) {
        throw new Error(`Campos inválidos: ${errors}`);
      }
      await submitForm();
    } catch (error) {
      ErrorMessage(error.message);
    }
  };

  useEffect(() => {
    if (
      isClean &&
      (values.id_customer ||
        values.partner.length > 0 ||
        values.period.dateFrom !== today("YYYY/MM/DD") ||
        values.period.dateTo !== today("YYYY/MM/DD"))
    ) {
      setIsClean(false);
    }
  }, [values, isClean]);

  useEffect(() => {
    if (values.id_customer) {
      setFieldValue("partner", []);
    }
  }, [values.id_customer]);


  const renderContent = () => {
    if (!dataReport || !dataBarChart.length) {
      return (
        <div className="w-full min-h-[60vh] flex justify-center items-center">
          <NotContent />
        </div>
      );
    }

    if (isPendingBar && isPendingPie) {
      return (
        <div className="w-full min-h-[60vh] flex justify-center items-center">
          <Spinner animation="border" />
        </div>
      );
    }

    {/** RENDER CONTENT */}
    return (
      <div className="space-y-3">
        <div className="flex justify-end items-center gap-2">
          <div className="flex flex-row bg-gray-25 p-2 border border-gray-200 rounded gap-2  w-[250px] bg-white">
            <Icon
              icon="date_range"
              className="flex items-center justify-center text-[16px] text-secondary"
            />
            <span className="font-medium text-[14.5px] leading-[20px] text-secondary text-nowrap line-clamp-1">
              {dateFormat(values.period.dateFrom, "YYYY/MM/DD")} -{" "}
              {dateFormat(values.period.dateTo, "YYYY/MM/DD")}
            </span>
          </div>
        </div>
        <CardsCustomers data={dataReport} />
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-4 md:gap-6">
        <div className="col-span-1 md:col-span-2 lg:col-span-3">
            <PieChartReport data={dataReport} />
          </div>
       
          <div className="col-span-1 md:col-span-2 lg:col-span-6">
            <GraphByDayDashboard data={dataBarChart} />
          </div>
          <div className="col-span-1 md:col-span-2 lg:col-span-3">
          <PartnerGraphDashboard
            data={summaryPartners}
            loading={isPendingPartnert}
          />
        </div>
        </div>
      </div>
    );
  };

  const handleMultiSelect = (selected) => {
      if(values.id_customer === 'all') {
        setFieldValue('partner', ['all'])
      };
      if (selected.includes("all")) {
        setFieldValue("partner", ["all"]);
        return;
      }

      if (values.partner.includes("all") && selected.length > 0) {
        const filtered = selected.filter((v) => v !== "all");
        setFieldValue("partner", filtered);
        return;
      }
      setFieldValue("partner", selected);
    
  }

  return (
    <div className="w-full space-y-3">
      <div className="bg-white rounded-lg !px-4 !py-2 gap-4">
        {/** FORM */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <SelectAndSearch
          options={[
              {
                value: "",
                label: "Selecciona un cliente",
                disabled: true
              },
              {
                value: "all",
                label: "Todos",
              },
              ...customersList.map((customer) => ({
                value: customer.idcustomer,
                label: customer.comercialname,
              })).sort((a, b) => a.label.localeCompare(b.label))
            ]}
            title="Cliente"
            name="id_customer"
            values={values.id_customer}
            handleChange={(e) => setFieldValue("id_customer", e)}
            onBlur={handleBlur}
            errors={errors && touched ? errors.id_customer : ""}
            isError={errors && errors.id_customer}
            placeholder="Busca un cliente"
            required
          />
          <MultiSelect
            options={partners}
            title="Partner"
            name="partner"
            multiple
            value={values.partner}
            onChange={(value) => handleMultiSelect(value)}
            onBlur={handleBlur}
            errors={errors && touched ? errors.partner : ""}
            isError={errors && errors.partner}
            required
          />
          <DateFilters
            setFilterFrom={(e) => setFieldValue("period.dateFrom", e)}
            setFilterTo={(e) => setFieldValue("period.dateTo", e)}
            errors={errors}
            required
            isClean={isClean}
          />
        </div>
        <div className="flex justify-end gap-2">
          <_Button
            icon="clear_all"
            onClick={() => {
              resetForm();
              setDataReport([]);
              setDataBarChart([]);
              setIsClean(true);
            }}
            style="none"
            title="Limpiar"
            disabled={isPendingBar && isPendingPie}
          />
          <_Button
            icon="analytics"
            onClick={async () => await _validate()}
            style="primary"
            title="Generar reporte"
            disabled={isPendingBar && isPendingPie}
            loading={isPendingBar && isPendingPie}
            className="min-w-[200px]"
          />
        </div>
      </div>

      {renderContent()}
    </div>
  );
};

export default _CustomerDashboard;
